import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {APP_MESSAGES} from "../../enums/enums";
import {ModalService} from "../../services/modal.service";
import {DocumentService} from "../../services/document.service";
import {E_ENDPOINTS} from "../../helpers/params/loader-params";
import {Subject} from "rxjs/Subject";

declare var $:any;

@Component({
  selector: 'nv-confirm-modal',
  templateUrl: './nv-confirm-modal.component.html',
  styles: []
})
export class NvConfirmModalComponent implements OnInit {

  private onConfirm:() => void;
  private unsubscribe: Subject<void> = new Subject<void>();
  @ViewChild("confirmModal") confirmModal:ElementRef;

  message:string = "";

  constructor(private modalService: ModalService,
              private documentService:DocumentService) { }

  ngOnInit() {
    this.modalService
      .onModalRequest
      .filter(
        appMessage => appMessage.type === APP_MESSAGES.POPUP_CONFIRM)
      .subscribe(
        appMessage => this.confirm(appMessage.content));
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  private confirm(content:any){
    console.log('confirm');
    this.message = content.message;
    this.onConfirm = content.action;
    $(this.confirmModal.nativeElement).modal("show");
  }

  confirmNo(){
    console.log('no');
    $(this.confirmModal.nativeElement).modal("hide");
  }

  confirmYes(){
    console.log('yes');
    //this.documentService.remove(this.endpointId);
    this.onConfirm();
    $(this.confirmModal.nativeElement).modal("hide");
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/modals/nv-confirm-modal/nv-confirm-modal.component.ts